
import { defineComponent, ref, toRefs, watch } from 'vue'
import { useRoute } from 'vue-router'

// Components
import Logo from './Logo.vue'

export default defineComponent({
    name: 'Header',
    components: {
        Logo,
    },
    props: {
        isMobileMenuOpen: { type: Boolean, default: false },
    },
    setup(props, { emit }) {
        const { isMobileMenuOpen } = toRefs(props)
        const route = useRoute()
        const currentRoute = ref('/')

        const navLinks = [
            { id: '/', name: 'Hem' },
            {
                id: 'services',
                name: 'Tjänster',
            },
            {
                id: 'idea-vision',
                name: 'Idé & Vision',
            },
            {
                id: 'contact',
                name: 'Kontakta oss',
            },
        ]

        const handleMobileNavToggle = () => {
            const closeBtn = document.getElementById('mobile-nav-close')

            if (!isMobileMenuOpen.value) {
                closeBtn?.classList.add('animate')
            } else {
                closeBtn?.classList.remove('animate')
            }

            emit('toggle-mobile-menu', !isMobileMenuOpen)
        }

        const handleMobileNavlinkClick = () => {
            handleMobileNavToggle()
        }

        watch(route, () => {
            currentRoute.value = route.path
        })

        return {
            navLinks,
            currentRoute,
            handleMobileNavToggle,
            handleMobileNavlinkClick,
        }
    },
})
